import React, { Component } from "react";
import { connect } from 'react-redux';
import * as wActs from "../actions/website-actions";
import {Link} from 'react-router-dom';
import * as wConst from "../consts/website-consts";
import {addTask} from "domain-task";
const AppUrl = 'https://app.swinity.com/api/creatives';
const AdSlot = {
  "RandomNumber": Math.abs(Math.floor(Math.random(1) * 100000)),
  "Click": {
    "Guid": "2610abed-17d4-4f81-b862-10ddc0d80eed"
  },
  "Creative": {
    "Code": "ADVERTISEHERE"
  }
};

class LinkButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Zone: props.Zone,
      Links: [],
      Colors: [
        "purple","blue","green","orange","black",
        "grey","red","yellow","orange","black",
        "grey","red","yellow","orange","black"
      ],
      Country: wActs.isNullOrEmpty(this.props.Country) ? this.props.WebPage.Request.CountryCode : this.props.Country,
      ContainerClass: props.ContainerClass ? props.ContainerClass : "link-buttons-container",
      ButtonClass: props.ButtonClass ? props.ButtonClass : "link-button",
      Count: this.props.Count ? this.props.Count : 15,
      Min: this.props.Min ? this.props.Min : 15,
      Max: this.props.Max ? this.props.Max : 15,
      MaxBuy: this.props.MaxBuy ? this.props.MaxBuy : 0,
      MinBuy: this.props.MaxBuy ? this.props.MinBuy : 0,
    };
  }

  getColorClass(i) {
    if(i>this.state.Colors.length) {i=0}
    return this.state.Colors[i];
  }

  componentDidMount() {

  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  handleClick(e,cre) {
    try {
      if(typeof window !== "undefined" && typeof window.ga !== "undefined") {
        window.ga('send', 'event', 'Banner', 'Click', cre.Click.Name);
      }
      if(typeof window !== "undefined" && typeof window.gtag !== "undefined") {
        window.gtag('event', 'view_promotion', [
          {"creative_name": cre.Creative.Title, "creative_slot": cre.Zone.Name + " - " + window.location.hostname, "id": cre.Click.Guid, "name": cre.Click.Name}
        ]);
      }
    } catch(ex) {}
    cre.Click.Guid = this.CreateGuid();
    this.apiClick(cre);
  }

  CreateGuid() {
    function _p8(s) {
      let p = (Math.random().toString(16)+"000000000").substr(2,8);
      return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
  }

  apiClick(cre) {
    let pge = this.props.WebPage;
    let clk = {
      Channel: pge.Request.Domain.Name.toLowerCase(),
      CountryCode: pge.Request.CountryCode,
      IpAddress: pge.Request.IpAddress,
      AnonymousId: pge.Request.AnonymousId,
      Ads: [],
      UserId:  pge.Request.UserId
    };
    clk.Ads.push(cre);


    let headers = {
      "X-Alt-Referer": window.location.href,
      "Content-type": "application/json"
    };
    if (!wActs.isNullOrEmpty(this.props.AnonymousId)) {
      headers["X-Alt-AnonymousId"] = this.props.AnonymousId;
    } //Do Not Need Any Resp, Etc.. Log On Error Thats It
    fetch(`${AppUrl}/impression?Click=true`, {headers: headers, method: "POST", body: JSON.stringify(clk) })
      .catch((ex) => {
        console.log("Error in click call swbanner",ex);
      });
  }

  getLinkTitleTranslation(title) {
    try {
      let tit = wActs.replaceAll(" ","",title).toLowerCase();
      let tran = this.props.WebPage.Translations['promo.button.' + tit];
      if(wActs.isNullOrEmpty(tran)) { return title; } else { return tran; }
    }catch(ex){}
    return title;
  }

  getLinks() { //Filter Links For Zone, Include/Exclude Logic
    let links = this.props.Ads.ApiResult.filter((ad)=>{if(!ad.Zone) {return false} else {return ad.Zone.Code == this.props.Zone}});
    let flinks = [];
    let host = wActs.getSubdomain(new URL(this.props.WebPage.ServerParams.Referer).host);
    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    if(wActs.isNullOrEmpty(acc)) { acc=this.props.WebPage.Request.CountryCode; }

    links.map((lnk)=>{
      let add = true;
      let targethost = wActs.getSubdomain(new URL(lnk.Creative.TargetUrl).host);
      //console.log(`${host} !== ${targethost}`);
      if(targethost == host) {
        add = false;
      }
      if(lnk.Include.length>0) {
        lnk.Include.map((inc)=>{
          if(inc.Type == "Country") {
            if(inc.Value !== acc) {
              add = false;
            }
          }
        });
      }
      if(lnk.Exclude.length>0) {
        lnk.Exclude.map((exc)=>{
          if(exc.Type == "Country") {
            if(exc.Value == acc) {
              add = false;
            }
          }
          if(exc.Type == "Channel") {
            if(exc.Value == this.props.WebPage.Request.Domain.Name) {
              add = false;
            }
          }
        });
      }
      if(add) {flinks.push(lnk)}
    });
    return flinks;
  }

  render() {
    let nlinks = this.getLinks();
    if(nlinks.length <=0 ) return (
      <div className={this.state.ContainerClass}></div>
    );

    //console.log("Links B4 Sort", nlinks);

    let links = nlinks.sort((a,b) => {return a.Index - b.Index});

    //console.log("Links After Sort", nlinks);

    return (
      <div className={this.state.ContainerClass}>
        {links.map((lnk,i) => {
          //No Image Load Here
          if(lnk.Rel.toLowerCase() == "hide") {
            return (
              <a href={lnk.Creative.TargetUrl} onClick={(e)=> {
                e.preventDefault();
                this.handleClick(e,lnk);
                window.open(lnk.Creative.TargetUrl);
              }} key={"promolink-" + i} rel={lnk.Rel} className={`${this.state.ButtonClass} ${lnk.Template}`}>{this.getLinkTitleTranslation(lnk.Creative.Title)}</a>
            );
          } else {
            return (
              <button onClick={(e)=> {
                e.preventDefault();
                this.handleClick(e,lnk);
                window.open(lnk.Creative.TargetUrl);
              }} key={"promolink-" + i} className={`${this.state.ButtonClass} ${lnk.Template}`}>{this.getLinkTitleTranslation(lnk.Creative.Title)}</button>
            );
          }
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Template: state.Website.Page.Template,
    Ads: state.Ads.SSRAds
  };
}

export default connect(mapStateToProps)(LinkButtons);
